import { useState, useEffect } from 'react';
import { updateUserAttributes } from 'aws-amplify/auth';
import { refreshSession } from '../services/RefreshSession';

const CONSENT_KEY = 'chatWidgetConsent';

export const useFeedbackConsent = (isAuthenticated: boolean, userEmail: string | null) => {
  const [feedbackConsent, setFeedbackConsent] = useState<boolean | null>(null);

  useEffect(() => {
    const loadFeedbackConsent = async () => {
      if (isAuthenticated && userEmail) {
        try {
          const savedConsent = sessionStorage.getItem(CONSENT_KEY);
          if (savedConsent !== null) {
            setFeedbackConsent(savedConsent === 'true');
            return;
          }

          const session = await refreshSession();
          const consent = session?.tokens?.idToken?.payload['custom:feedback_consent'];
          const consentValue = consent === 'true';
          setFeedbackConsent(consentValue);
          sessionStorage.setItem(CONSENT_KEY, String(consentValue));
        } catch (error) {
          console.error('Error loading feedback consent:', error);
          setFeedbackConsent(null);
        }
      } else {
        setFeedbackConsent(null);
      }
    };
    loadFeedbackConsent();
  }, [isAuthenticated, userEmail]);

  const saveFeedbackConsent = async (consent: boolean) => {
    try {
      await updateUserAttributes({
        userAttributes: {
          'custom:feedback_consent': consent ? 'true' : 'false',
        },
      });
      setFeedbackConsent(consent);
      sessionStorage.setItem(CONSENT_KEY, String(consent));
    } catch (error) {
      console.error('Error saving feedback consent:', error);
    }
  };

  return {
    feedbackConsent,
    saveFeedbackConsent,
  };
};
